export const SYNC_COUNTERS_STATUS = '@@countersStatus/sync'

export const UPDATE_COUNTERS_STATUS = '@@countersStatus/update'

export const RESET_COUNTERS_STATUS = '@@countersStatus/reset'
